export default __webpack_public_path__ + "static/media/middle_leaf.21653609.png";